import React from 'react';
export function Footer() {
  return <footer className="bg-brand-steel px-4 py-4 text-center text-white" data-id="element-65" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-3xl space-y-1.5" data-id="element-66" data-mp="3gfiyctkyyvje">
        <p className="text-[11px] font-semibold text-brand-line" data-id="element-67" data-mp="3gh3rqfvjs8fo">
          © 2026 DIESEL DIAGNOSTIC PRO™ — All Rights Reserved.
        </p>
        <p className="text-[11px] font-medium leading-snug text-brand-line/80" data-id="element-68" data-mp="36ooajks2rnvu">
          DIESEL DIAGNOSTIC PRO™ is a professional diesel diagnostic reference resource. It does
          not replace required training, manufacturer instructions, workplace safety procedures or
          qualified professional judgment.
        </p>
        <p className="text-[11px] font-semibold text-brand-line" data-id="element-69" data-mp="3ldu874b9l61m">
          Terms &amp; Conditions • Privacy Policy • Contact Support:{' '}
          <a href="mailto:kitonline27@gmail.com" className="underline hover:text-brand-yellow" data-id="element-70" data-mp="29zgl41oc4umn">
            kitonline27@gmail.com
          </a>
        </p>
      </div>
    </footer>;
}